var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudUpload } from '@fortawesome/pro-regular-svg-icons/faCloudUpload';
import { faSpinner } from '@fortawesome/pro-regular-svg-icons/faSpinner';
import { faImage } from '@fortawesome/pro-regular-svg-icons/faImage';
import { faIcons } from '@fortawesome/pro-regular-svg-icons/faIcons';
import { faFileAlt } from '@fortawesome/pro-regular-svg-icons/faFileAlt';
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes';
import { faSearch } from '@fortawesome/pro-regular-svg-icons/faSearch';
import { useDispatch, useSelector } from 'react-redux';
import { IMAGE_FILES, DOCUMENT_FILES, ICON_FILES, SPECIAL_FOLDER_IDS, } from './constants';
import { CloseIcon, customStyles, FileContainer, ImageBlock, MediaTitle, ModalHeader, ModalHeaderLeft, NoFilesContainer, NoFilesContainerFileTypes, NoFilesContainerFileTypesOuter, SearchBarContainer, SelectWrapper, StyledClosehIcon, StyledSearchIcon, StyledSearchInput, TitleBlock, UploadButton, UploadInput, AssetsTitle, ErrorContainter, ConfirmationMessage, } from './styles';
import { selectFiles, selectFileType, selectFolders, selectLoading, selectSelectedFolderId, selectSetSearchValue, selectFilesWithLoadingError, selectErrorSavingFile, } from '../../store/media/selectors';
import { deleteFile, getFiles, getFolders, saveFile, setFilesBeforeUpload, updateErrorSavingFile, } from '../../store/media/actions';
import Select from 'react-select';
import { CommonModal } from '@appspotr/ui-kit';
import { SingleFile } from './FileItem';
import { setFileType, setSearchValue } from '../../store/media/reducer';
import { checkMultipleImagesDimensions, checkMultipleImagesHasAlpha, } from './helper';
import { createSearchFunction } from 'utils';
import { ErrorMessage } from 'containers/MakeTemplateBasicPage/styles';
export var MediaExplorer = function (_a) {
    var _b;
    var appId = _a.appId, scopeToUse = _a.scopeToUse, aptVersion = _a.aptVersion, onSelectFile = _a.onSelectFile, setIsOpen = _a.setIsOpen, _c = _a.acceptedTypes, acceptedTypes = _c === void 0 ? "".concat(IMAGE_FILES, ",").concat(ICON_FILES, ",").concat(DOCUMENT_FILES) : _c, mediaBucketURL = _a.mediaBucketURL, iconBucketURL = _a.iconBucketURL, fileBucketURL = _a.fileBucketURL, _d = _a.isMediaModal, isMediaModal = _d === void 0 ? true : _d, topBarContent = _a.topBarContent, PermissionsWrapper = _a.PermissionsWrapper, showImageModalFunction = _a.showImageModalFunction, showPDFFunction = _a.showPDFFunction, linkFileType = _a.linkFileType, onMediaRemove = _a.onMediaRemove;
    var pathname = window.location.pathname;
    var appIdToUse = appId ? appId : pathname === null || pathname === void 0 ? void 0 : pathname.split('/')[4];
    var scope = scopeToUse ? scopeToUse : "app:".concat(appIdToUse);
    var fileTypeOptions = [
        { value: acceptedTypes, label: 'All' },
        { value: IMAGE_FILES, label: 'Images' },
        { value: DOCUMENT_FILES, label: 'Files' },
        { value: ICON_FILES, label: 'Icons' },
    ];
    var isLastImageInRow = false;
    var dispatch = useDispatch();
    var _e = useState(''), selectedFile = _e[0], setSelectedFile = _e[1];
    var _f = useState([]), deleteFileOnProgress = _f[0], setDeleteFileOnProgress = _f[1];
    var _g = useState(false), isDeleteConfirmationOpen = _g[0], setIsDeleteConfirmationOpen = _g[1];
    var _h = useState(false), uploadError = _h[0], setUploadError = _h[1];
    var _j = useState(false), dimensionError = _j[0], setDimensionError = _j[1];
    useEffect(function () {
        dispatch(getFolders());
        dispatch(getFiles(scope));
    }, [dispatch, scope, aptVersion]);
    var files = useSelector(selectFiles);
    var selectedFileForModal = useSelector(selectFileType);
    var selectedFileType = linkFileType || selectedFileForModal;
    var selectedFileTypeOptions = selectedFileType
        ? (_b = fileTypeOptions.find(function (fileTypeOption) {
            return fileTypeOption.label.toLowerCase() === selectedFileType.toLowerCase();
        })) === null || _b === void 0 ? void 0 : _b.value
        : acceptedTypes;
    var filesOfselectedFileType = files === null || files === void 0 ? void 0 : files.filter(function (file) { var _a; return (_a = selectedFileTypeOptions === null || selectedFileTypeOptions === void 0 ? void 0 : selectedFileTypeOptions.split(',')) === null || _a === void 0 ? void 0 : _a.includes((file === null || file === void 0 ? void 0 : file.mime_type) || ''); });
    var loading = useSelector(selectLoading);
    var searchValue = useSelector(selectSetSearchValue);
    var folders = useSelector(selectFolders);
    var selectedFolderId = useSelector(selectSelectedFolderId);
    var filesWithLoadingError = useSelector(selectFilesWithLoadingError);
    var errorSavingFile = useSelector(selectErrorSavingFile);
    var searchFn = createSearchFunction(['name']);
    var filteredFiles = searchFn(searchValue, filesOfselectedFileType).filter(function (file) { return !filesWithLoadingError.includes(file.id); });
    var target = "".concat(scope || "app:".concat(appIdToUse), ":media");
    useEffect(function () {
        var timer = setTimeout(function () {
            dispatch(updateErrorSavingFile(false));
            if (timer)
                clearTimeout(timer);
        }, 3000);
    }, [dispatch, errorSavingFile]);
    useEffect(function () {
        return function () {
            dispatch(updateErrorSavingFile(false));
        };
    }, [dispatch]);
    var getFileBucket = function (fileType) {
        var bucket = mediaBucketURL;
        switch (fileType) {
            case 'image/svg+xml':
                bucket = iconBucketURL;
                return bucket;
            case 'application/pdf':
                bucket = fileBucketURL;
                return bucket;
            default:
                return bucket;
        }
    };
    var OnDelete = function (fileId) {
        dispatch(deleteFile(fileId, scope));
    };
    var handleFileChange = function () { return function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var files, arrayFromFileCount, filesArray, dimensionCheckPassed, imagesHasAlpha, uploadingFilesArray, _loop_1, _i, _a, file;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    files = e.target.files;
                    arrayFromFileCount = Array.from(Array(files.length).keys());
                    filesArray = Object.values(files);
                    if (!(scope === "app:".concat(appId, ":build"))) return [3 /*break*/, 2];
                    return [4 /*yield*/, checkMultipleImagesDimensions(filesArray)];
                case 1:
                    dimensionCheckPassed = _d.sent();
                    _d.label = 2;
                case 2:
                    if (!dimensionCheckPassed) return [3 /*break*/, 4];
                    return [4 /*yield*/, checkMultipleImagesHasAlpha(filesArray)];
                case 3:
                    //If the image has alpha and 11000*11000 px, when checking, the page crashes. So checking the dimension first and then checking alpha
                    imagesHasAlpha = _d.sent();
                    _d.label = 4;
                case 4:
                    uploadingFilesArray = arrayFromFileCount.map(function (item, index) {
                        return {
                            id: "".concat(files[index].name).concat(Math.random()).concat(item),
                            isUploading: true,
                            url: URL.createObjectURL(files[index]),
                            name: files[index].name,
                            mime_type: files[index].type,
                            file: files[index],
                        };
                    });
                    if ((dimensionCheckPassed && !imagesHasAlpha) ||
                        scope !== "app:".concat(appId, ":build")) {
                        // dimension check is applicable only for build page media
                        dispatch(setFilesBeforeUpload(uploadingFilesArray));
                        _loop_1 = function (file) {
                            if (file.id &&
                                file.file &&
                                scope &&
                                (((_b = folders[0]) === null || _b === void 0 ? void 0 : _b.id) || selectedFolderId)) {
                                dispatch(saveFile(file.id, file.file, (SPECIAL_FOLDER_IDS === null || SPECIAL_FOLDER_IDS === void 0 ? void 0 : SPECIAL_FOLDER_IDS.includes(selectedFolderId))
                                    ? (_c = folders[0]) === null || _c === void 0 ? void 0 : _c.id
                                    : selectedFolderId, scope));
                                uploadingFilesArray = uploadingFilesArray.filter(function (item) { return item.id !== file.id; });
                            }
                            else {
                                setUploadError(true);
                                setTimeout(function () {
                                    setUploadError(false);
                                }, 5000);
                            }
                        };
                        for (_i = 0, _a = uploadingFilesArray.reverse(); _i < _a.length; _i++) {
                            file = _a[_i];
                            _loop_1(file);
                        }
                    }
                    else {
                        setDimensionError(true);
                        setTimeout(function () {
                            setDimensionError(false);
                        }, 5000);
                    }
                    return [2 /*return*/];
            }
        });
    }); }; };
    var renderUploadButton = function () {
        return (_jsxs(UploadButton, { children: [loading ? (_jsx(FontAwesomeIcon, { icon: faSpinner, spin: true, width: 14, height: 14, fixedWidth: true, style: { marginRight: '8px' } })) : (_jsx(FontAwesomeIcon, { icon: faCloudUpload, width: 14, height: 14, fixedWidth: true, style: { marginRight: '8px' } })), "Upload", _jsx(UploadInput, { type: "file", accept: selectedFileTypeOptions, multiple: true, onChange: !loading ? handleFileChange() : function () { return null; } })] }));
    };
    var renderNoImageBlock = function () {
        return (_jsxs(NoFilesContainerFileTypes, { children: [_jsx(FontAwesomeIcon, { icon: faImage, color: "#07285B", fixedWidth: true, size: "2x", style: { color: '#666', marginBottom: '10px' } }), "Images ", _jsx("br", {}), ".png .jpeg .jpg"] }));
    };
    var renderNoIconBlock = function () {
        return (_jsxs(NoFilesContainerFileTypes, { children: [_jsx(FontAwesomeIcon, { icon: faIcons, color: "#07285B", fixedWidth: true, size: "2x", style: { color: '#666', marginBottom: '10px' } }), "Icons ", _jsx("br", {}), ".svg"] }));
    };
    var renderNoPDFBlock = function () {
        return (_jsxs(NoFilesContainerFileTypes, { children: [_jsx(FontAwesomeIcon, { icon: faFileAlt, color: "#07285B", fixedWidth: true, size: "2x", style: { color: '#666', marginBottom: '10px' } }), "Documents", _jsx("br", {}), ".pdf"] }));
    };
    return (_jsxs(_Fragment, { children: [_jsx(CommonModal, __assign({ width: "700px", height: "600px", modalType: "delete", cancel: "Cancel", disabled: false, title: "Delete Media File", action: "Delete Media File", active: isDeleteConfirmationOpen, hideModal: function () {
                    setSelectedFile('');
                    setIsDeleteConfirmationOpen(false);
                }, onClick: function () {
                    OnDelete(selectedFile);
                    setSelectedFile('');
                    setIsDeleteConfirmationOpen(false);
                    onMediaRemove && onMediaRemove();
                } }, { children: scope === "app:".concat(appIdToUse, ":build") ? (_jsx(ConfirmationMessage, { children: "This file will be permanently deleted from your media library if you proceed" })) : (_jsx(ConfirmationMessage, { children: "This file will be permanently deleted from your media library if you proceed. To ensure that there is no impact to the live app, please make sure that this file is not used in other places in your app, before deleting it." })) })), isMediaModal && (_jsxs(TitleBlock, { children: [_jsx(MediaTitle, { children: "Media" }), _jsx(CloseIcon, __assign({ onClick: function () {
                            setIsOpen(false);
                        } }, { children: _jsx(StyledClosehIcon, { icon: faTimes }) }))] })), _jsxs(ModalHeader, __assign({ isMediaModal: isMediaModal }, { children: [_jsx(ModalHeaderLeft, { children: isMediaModal ? (_jsx(SelectWrapper, { children: _jsx(Select, { name: "type", placeholder: "All", defaultValue: fileTypeOptions.find(function (option) {
                                    return acceptedTypes === null || acceptedTypes === void 0 ? void 0 : acceptedTypes.includes(option.value);
                                }), options: fileTypeOptions.filter(function (option) {
                                    return acceptedTypes === null || acceptedTypes === void 0 ? void 0 : acceptedTypes.includes(option.value);
                                }), onChange: function (option) { return dispatch(setFileType(option === null || option === void 0 ? void 0 : option.label)); }, minHeight: "35px", height: "35px", width: "128px", styles: customStyles }) })) : (_jsx(AssetsTitle, { children: "Assets" })) }), _jsxs(SearchBarContainer, { children: [_jsx(StyledSearchIcon, { icon: faSearch }), _jsx(StyledSearchInput, { type: "text", placeholder: "Search Assets", value: searchValue, onChange: function (e) { return dispatch(setSearchValue(e.target.value)); } })] }), topBarContent && topBarContent, PermissionsWrapper ? (_jsx(PermissionsWrapper, __assign({ target: target, action: "create" }, { children: renderUploadButton() }))) : (renderUploadButton())] })), errorSavingFile && (_jsxs(ErrorContainter, { children: [_jsx("div", { children: "Something went wrong while uploading files" }), _jsx("div", __assign({ onClick: function () { return dispatch(updateErrorSavingFile(false)); } }, { children: _jsx(FontAwesomeIcon, { color: "black", size: "1x", icon: faTimes }) }))] })), dimensionError && (_jsxs(ErrorContainter, { children: [_jsx("div", { children: "Images should not be transparent and dimension must be within 800px and 1300px." }), _jsx("div", __assign({ onClick: function () { return setDimensionError(false); } }, { children: _jsx(FontAwesomeIcon, { color: "black", size: "1x", icon: faTimes }) }))] })), _jsxs(ImageBlock, __assign({ isMediaModal: isMediaModal }, { children: [filteredFiles.length === 0 && !loading && (_jsxs(NoFilesContainer, { children: ["Upload media files to use in your app", _jsx(NoFilesContainerFileTypesOuter, { children: !linkFileType || linkFileType === 'all' ? (_jsxs(_Fragment, { children: [renderNoPDFBlock(), renderNoImageBlock(), renderNoIconBlock()] })) : linkFileType === 'images' ? (renderNoImageBlock()) : linkFileType === 'files' ? (renderNoPDFBlock()) : (renderNoIconBlock()) })] })), filteredFiles && filteredFiles.length !== 0 && (_jsxs(FileContainer, __assign({ isMediaModal: isMediaModal }, { children: [filteredFiles.map(function (file, index) {
                                isLastImageInRow =
                                    (index + 1) / 3 - Math.floor((index + 1) / 3) == 0;
                                return (_jsx(SingleFile, { getFileBucket: getFileBucket, file: file, onClick: function () {
                                        return onSelectFile &&
                                            onSelectFile(__assign(__assign({}, file), { url: "".concat(getFileBucket(file.mime_type), "/").concat(file.external_id) }));
                                    }, openPDF: showPDFFunction, showImgModal: showImageModalFunction, target: target, deleteFileOnProgress: deleteFileOnProgress, deleteFile: function (e) {
                                        if (file.id) {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            setDeleteFileOnProgress(__spreadArray(__spreadArray([], deleteFileOnProgress, true), [
                                                file.id,
                                            ], false));
                                            OnDelete(file.id);
                                        }
                                        else {
                                            setUploadError(true);
                                            setTimeout(function () {
                                                setUploadError(false);
                                            }, 5000);
                                        }
                                    }, isMediaModal: isMediaModal, isLastImageInRow: isLastImageInRow, PermissionsWrapper: PermissionsWrapper, onSelectFile: setSelectedFile, onDeleteConfirmation: setIsDeleteConfirmationOpen }, file.id));
                            }), uploadError && (_jsx(ErrorMessage, { children: "Something went wrong, Please retry!" }))] })))] }))] }));
};
